const ComponentBase = require('../../base/ComponentBase');
const CommonUtil = require('../../utils/CommonUtil');
/**
 * @ignore
 * @constructor
 * @classdesc 地震烈度模型展示
 * @augments G.base.ComponentBase
 * @alias G.model.EarthquakeIntensity
 * @param {Object} options 构造参数
 * @example
 * //使用示例代码
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
    },

    /**
     * @inheritdoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
    },

    /**
     * @inheritdoc
     * 
     */
    unload() {
        ComponentBase.prototype.unload.call(this);
    },

    /**
     * 展示烈度范围
     * @method
     * @memberOf G.model.EarthquakeIntensity.prototype
     * @param {Object} opts 
     */
    showIntensityRange(opts) {

    },

    /**
     * 清除烈度范围
     * @method
     * @memberOf G.model.EarthquakeIntensity.prototype
     */
    clearIntensityRange() {

    }
});
module.exports = component;